"use client";

import { useServiceData } from "../../hooks/useServiceData";
import React from "react";
import styles from "./HostingServicesCardSection.module.css";
import hostingServicesData from "../../data/hosting";
import ServiceCard from "../../components/ServiceCard";

export default function HostingServicesCardSection() {
  const { data: backendPageData } = useServiceData();
  const services = backendPageData?.services;
  const displayData = services?.items || hostingServicesData;

  return (
    <section className={`py-5 ${styles.section}`}>
      <div className="container">
        <div
          className={`text-center mb-5 ${styles.heading}`}
          data-reveal="fade"
        >
          <span className={styles.eyebrow}>{services?.title || "Web Hosting Services"}</span>
          <h2 className={styles.title}>{services?.subtitle || "Managed, Fast and Secure Websites"}</h2>
        </div>

        <div className="row g-4" data-reveal="stagger-mix">
          {displayData.map((service, index) => (
            <div className="col-12 col-md-6 col-lg-4" key={index}>
              <ServiceCard {...service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
